import { render, staticRenderFns } from "./DeclareForm.vue?vue&type=template&id=2f5fe6ff&scoped=true&"
import script from "./DeclareForm.vue?vue&type=script&lang=js&"
export * from "./DeclareForm.vue?vue&type=script&lang=js&"
import style0 from "./DeclareForm.vue?vue&type=style&index=0&id=2f5fe6ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fe6ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRadio,VRadioGroup,VRow,VTextField})
